import styles from './NotificationSoundVolume.module.css';
import { useNotificationSoundStore } from '../model/notification-sound-store';
import { playPreviewSound } from '../lib/notification-sounds';

export const NotificationSoundVolume: React.FC = () => {
  const enabled = useNotificationSoundStore((s) => s.enabled);
  const volume = useNotificationSoundStore((s) => s.volume);
  const setVolume = useNotificationSoundStore((s) => s.setVolume);
  const percent = Math.round(volume * 100);

  return (
    <span className={styles.root}>
      <input
        className={styles.volumeSlider}
        type="range"
        min={0}
        max={100}
        step={5}
        value={percent}
        disabled={!enabled}
        onChange={(e) => setVolume(Number(e.target.value) / 100)}
        onPointerUp={() => enabled && playPreviewSound(useNotificationSoundStore.getState().volume)}
        aria-label="Громкость уведомлений"
      />
      <span className={styles.value}>{enabled ? `${percent}%` : 'выкл'}</span>
    </span>
  );
};
